import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=f2000286&scoped=true"
import script from "./EditAttribute.vue?vue&type=script&lang=js"
export * from "./EditAttribute.vue?vue&type=script&lang=js"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=f2000286&prod&lang=scss&scoped=true"
import style1 from "./EditAttribute.vue?vue&type=style&index=1&id=f2000286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2000286",
  null
  
)

export default component.exports